<template>
  <div
    class="lg:flex justify-center"
  >
    <div class="max-w-6xl px-6 xl:px-0">
      <Carousel
        ref="carousel"
        v-model="activeSlide"
        class="testimonial-container"
        @slide-start="slideChange"
      >
        <Slide key="0">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <img
              src="/img/libormertl.webp"
              class="w-50 w-full"
              sizes="md:600px"
            />
            <div class="lg:p-8 h-full hidden md:block">
              <div
                class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12"
                v-html="$t('club.testimonials.libor.text')"
              />
              <div>
                <h3 class="font-light">
                  {{ $t("club.testimonials.libor.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("club.testimonials.libor.position") }}
              </div>
            </div>
          </div>
        </Slide>
        <Slide key="1">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <img
              src="/img/david.jpg"
              class="w-50 w-full"
              sizes="md:600px"
            />
            <div class="lg:p-8 h-full hidden md:block">
              <div
                class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12"
                v-html="$t('membership.joinUs.testimonials.david.text')"
              />
              <div>
                <h3 class="font-light">
                  {{ $t("membership.joinUs.testimonials.david.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("membership.joinUs.testimonials.david.position") }}
              </div>
            </div>
          </div>
        </Slide>
        <Slide key="2">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <img
              src="/img/karadzovova.webp"
              class="w-50 w-full"
              sizes="md:600px"
            />
            <div class="lg:p-8 h-full hidden md:block">
              <div
                class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12"
                v-html="$t('club.testimonials.karadzovova.text')"
              />
              <div>
                <h3 class="font-light">
                  {{ $t("club.testimonials.karadzovova.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("club.testimonials.karadzovova.position") }}
              </div>
            </div>
          </div>
        </Slide>
        <Slide key="3">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <img
              src="/img/martin_holecko_web_foto.png"
              class="w-50 w-full"
              sizes="md:600px"
            />
            <div class="lg:p-8 h-full hidden md:block">
              <div
                class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12"
                v-html="$t('homepage.joinUs.testimonials.holecko.text')"
              />
              <div>
                <h3 class="font-light">
                  {{ $t("homepage.joinUs.testimonials.holecko.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("homepage.joinUs.testimonials.holecko.position") }}
              </div>
            </div>
          </div>
        </Slide>
        <Slide key="4">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <img
              src="/img/Vit_Horky_czech_founders_opero.jpg"
              class="w-50 w-full"
              sizes="md:600px"
            />
            <div class="lg:p-8 h-full hidden md:block">
              <div
                class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12"
                v-html="$t('homepage.joinUs.testimonials.vit.text')"
              />
              <div>
                <h3 class="font-light">
                  {{ $t("homepage.joinUs.testimonials.vit.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("homepage.joinUs.testimonials.vit.position") }}
              </div>
            </div>
          </div>
        </Slide>
				<Slide key="5">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <img
              src="/img/adam-ondracek.webp"
              class="w-50 w-full"
              sizes="md:600px"
            />
            <div class="lg:p-8 h-full hidden md:block">
              <div
                class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12"
                v-html="$t('club.testimonials.ondracek.text')"
              />
              <div>
                <h3 class="font-light">
                  {{ $t("club.testimonials.ondracek.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("club.testimonials.ondracek.position") }}
              </div>
            </div>
          </div>
        </Slide>
				<Slide key="6">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <img
              src="/img/louzenska_pavlina_opero.jpg"
              class="w-50 w-full"
              sizes="md:600px"
            />
            <div class="lg:p-8 h-full hidden md:block">
              <div
                class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12"
                v-html="$t('homepage.joinUs.testimonials.pavlina.text')"
              />
              <div>
                <h3 class="font-light">
                  {{ $t("homepage.joinUs.testimonials.pavlina.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("homepage.joinUs.testimonials.pavlina.position") }}
              </div>
            </div>
          </div>
        </Slide>
				<Slide key="7">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <img
              src="/img/janRamportl.jpg"
              class="w-50 w-full"
              sizes="md:600px"
            />
            <div class="lg:p-8 h-full hidden md:block">
              <div
                class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12"
                v-html="$t('membership.joinUs.testimonials.jan.text')"
              />
              <div>
                <h3 class="font-light">
                  {{ $t("membership.joinUs.testimonials.jan.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("membership.joinUs.testimonials.jan.position") }}
              </div>
            </div>
          </div>
        </Slide>
				<Slide key="8">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <img
              src="/img/Katerina.jpg"
              class="w-50 w-full"
              sizes="md:600px"
            />
            <div class="lg:p-8 h-full hidden md:block">
              <div
                class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12"
                v-html="$t('homepage.joinUs.testimonials.samanova.text')"
              />
              <div>
                <h3 class="font-light">
                  {{ $t("homepage.joinUs.testimonials.samanova.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("homepage.joinUs.testimonials.samanova.position") }}
              </div>
            </div>
          </div>
        </Slide>
				
        <template #addons>
          <Navigation />
        </template>
      </Carousel>

      <div
        class="md:mb-6 pt-6 flex justify-center"
      >
        <BubblesNavigationPaper
          :height="50"
          :width="40 * testimonials.length"
          start-width="50"
          :testimonials="testimonials"
          :change-testimonial="changeTestimonial"
          :current-selected="currentTestimonial"
          class="lg:mb-12"
        />
      </div>

      <Carousel
        ref="carousel"
        v-model="activeSlide"
        class="testimonial-container md:hidden"
        @slide-start="slideChange"
      >
        <Slide key="0">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <div class="lg:p-8 h-full">
              <div class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12">
                {{ $t("club.testimonials.libor.text") }}
              </div>
              <div>
                <h3 class="font-light">
                  {{ $t("club.testimonials.libor.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("club.testimonials.libor.position") }}
              </div>
            </div>
          </div>
        </Slide>
        <Slide key="1">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <div class="lg:p-8 h-full">
              <div class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12">
                {{ $t("membership.joinUs.testimonials.david.text") }}
              </div>
              <div>
                <h3 class="font-light">
                  {{ $t("membership.joinUs.testimonials.david.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("membership.joinUs.testimonials.david.position") }}
              </div>
            </div>
          </div>
        </Slide>
        <Slide key="2">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <div class="lg:p-8 h-full">
              <div class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12">
                {{ $t("club.testimonials.karadzovova.text") }}
              </div>
              <div>
                <h3 class="font-light">
                  {{ $t("club.testimonials.karadzovova.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("club.testimonials.karadzovova.position") }}
              </div>
            </div>
          </div>
        </Slide>
        <Slide key="3">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <div class="lg:p-8 h-full">
              <div class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12">
                {{ $t("homepage.joinUs.testimonials.holecko.text") }}
              </div>
              <div>
                <h3 class="font-light">
                  {{ $t("homepage.joinUs.testimonials.holecko.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("homepage.joinUs.testimonials.holecko.position") }}
              </div>
            </div>
          </div>
        </Slide>
        <Slide key="4">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <div class="lg:p-8 h-full">
              <div class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12">
                {{ $t("homepage.joinUs.testimonials.vit.text") }}
              </div>
              <div>
                <h3 class="font-light">
                  {{ $t("homepage.joinUs.testimonials.vit.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("homepage.joinUs.testimonials.vit.position") }}
              </div>
            </div>
          </div>
        </Slide>
				<Slide key="5">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <div class="lg:p-8 h-full">
              <div class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12">
                {{ $t("club.testimonials.ondracek.text") }}
              </div>
              <div>
                <h3 class="font-light">
                  {{ $t("club.testimonials.ondracek.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("club.testimonials.ondracek.position") }}
              </div>
            </div>
          </div>
        </Slide>
				<Slide key="6">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <div class="lg:p-8 h-full">
              <div class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12">
                {{ $t("homepage.joinUs.testimonials.pavlina.text") }}
              </div>
              <div>
                <h3 class="font-light">
                  {{ $t("homepage.joinUs.testimonials.pavlina.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("homepage.joinUs.testimonials.pavlina.position") }}
              </div>
            </div>
          </div>
        </Slide>
				<Slide key="7">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <div class="lg:p-8 h-full">
              <div class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12">
                {{ $t("membership.joinUs.testimonials.jan.text") }}
              </div>
              <div>
                <h3 class="font-light">
                  {{ $t("membership.joinUs.testimonials.jan.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("membership.joinUs.testimonials.jan.position") }}
              </div>
            </div>
          </div>
        </Slide>
				<Slide key="8">
          <div class="panel md:grid grid-cols-2 gap-4 min-w-full">
            <div class="lg:p-8 h-full">
              <div class="txt-q mt-4 lg:mt-0 mb-6 lg:mb-12">
                {{ $t("homepage.joinUs.testimonials.samanova.text") }}
              </div>
              <div>
                <h3 class="font-light">
                  {{ $t("homepage.joinUs.testimonials.samanova.name") }}
                </h3>
              </div>
              <div class="txt-t">
                {{ $t("homepage.joinUs.testimonials.samanova.position") }}
              </div>
            </div>
          </div>
        </Slide>
      </Carousel>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Draggable from "gsap/Draggable";
import { Carousel, Navigation, Slide, Pagination } from "vue3-carousel";

export default {
  data() {
    return {
      testimonials: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      currentTestimonial: 0,
      sections: [],
      isScrolling: false,
      gsapAnimation: null,
      scrollingTimer: null,
      scrollPos: 0,
      scrollDir: 1,
      lastScrollPos: -1,
      el: null,
      activeSlide: 0,
      imgTag: '<img src="/img/arrowDrag.svg" />',
    };
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.keyPressed);
  },

  mounted() {
    window.addEventListener("keydown", this.keyPressed);

    gsap.registerPlugin(ScrollToPlugin, Draggable);
  },
  methods: {
    changeTestimonial(t) {
      this.$refs.carousel.slideTo(t);
      this.currentTestimonial = t;
    },
    slideChange(data) {
      this.currentTestimonial = data.slidingToIndex;
    },
    keyPressed(event) {
      if (event.code === "ArrowLeft" && this.currentTestimonial > 0) {
        this.changeTestimonial(this.currentTestimonial - 1);
      } else if (
        event.code === "ArrowRight" &&
        this.currentTestimonial < this.testimonials.length - 1
      ) {
        this.changeTestimonial(this.currentTestimonial + 1);
      }
    },
  },
};
</script>

<style>
.testimonial-container {
  text-align: left;
}

.testimonial-container::-webkit-scrollbar {
  display: none;
}
.draggable-wrapper {
  display: flex !important;
}
</style>

<style scoped lang="scss">
.panel {
  height: 100%;
}

.txt-q {
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
}

.panel img {
  /*width: 600px;*/
  //height: 100%;
  height: -webkit-fill-available;
  object-fit: cover;
  max-height: 415px;
  @media screen and (max-width: 1024px) {
    height: -webkit-fill-available;
  }
  @media screen and (max-width: 768px) {
    height: unset;
  }
}

.test-img {
  height: -webkit-fill-available;
  //max-height: 400px;
  //margin-top: 24px;
  object-fit: cover;
}
</style>

<style lang="scss" scoped>
.testimonial-container:deep(.carousel__prev) {
	@media screen and (min-width: 1280px) {
    left: -95px;
  }
}
.testimonial-container:deep(.carousel__next) {
	@media screen and (min-width: 1280px) {
    right: -95px;
  }
}
:deep(.carousel__next) {
  background: #fff;
  border-radius: 100%;

  &:hover {
    background: #fff;
  }
}
:deep(.carousel__prev) {
  background: #fff;
  border-radius: 100%;
  &:hover {
    background: #fff;
  }
}

.carousel__icon {
  height: 20px !important;
}
</style>
